import styled from "styled-components"
import { Link } from "react-router-dom"

export const FooterWrapper = styled.footer`
  background-color: white;
  padding: 3rem 1rem 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 2rem 1rem 1rem;
  }
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 2rem 3rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 2rem 1rem;
    flex-direction: column;
    align-items: start;
    gap: 2rem;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: start;
    width: 100%;
  }
`

export const Logo = styled(Link)`
  display: block;

  svg {
    width: 200px;
    height: auto;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 150px;
    }
  }

  svg path {
    fill: ${({ theme }) => theme.textPrimary};
  }
`

export const Navigation = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 1rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 0.8rem;
  }
`

export const NavLink = styled(Link)`
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s ease;
  color: ${({ theme }) => theme.textPrimary};
  font-weight: 500;

  &:hover {
    color: #333;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.9rem;
  }
`

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: start;
    margin-bottom: 1rem;
  }
`

export const Email = styled.a`
  color: ${({ theme }) => theme.textPrimary};
  font-weight: 500;
  text-decoration: none;
  font-size: 1rem;
  text-align: right;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    text-align: left;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.9rem;
  }
`

export const Address = styled.p`
  color: ${({ theme }) => theme.textPrimary};
  font-weight: 500;
  font-size: 1rem;
  text-align: right;
  max-width: 350px;
  line-height: 1.5;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    text-align: left;
    max-width: 300px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.9rem;
    max-width: 280px;
  }
`

export const Copyright = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  color: ${({ theme }) => theme.textPrimary};
  font-weight: 500;

  a {
    color: ${({ theme }) => theme.textPrimary};
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.7rem;
    padding-top: 0.8rem;
  }
`
